/**
 * name: @storyblok/js
 * (c) 2025
 * description: SDK to integrate Storyblok into your project using JavaScript.
 * author: undefined
 */
var lt = Object.defineProperty;
var ht = (t, e, s) => e in t ? lt(t, e, {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: s
}) : t[e] = s;
var E = (t, e, s) => ht(t, typeof e != "symbol" ? e + "" : e, s);
const Dt = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/,
  dt = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u0888\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20C0\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFF\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u31EF\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC2\uFD40-\uFD4F\uFDCF\uFDFC-\uFDFF\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDC-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF76\uDF7B-\uDFD9\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC5\uDECE-\uDEDB\uDEE0-\uDEE8\uDEF0-\uDEF8\uDF00-\uDF92\uDF94-\uDFCA]/;
function O(t) {
  switch (t) {
    case 9:
    case 32:
      return !0;
  }
  return !1;
}
function G(t) {
  if (t >= 8192 && t <= 8202) return !0;
  switch (t) {
    case 9:
    // \t
    case 10:
    // \n
    case 11:
    // \v
    case 12:
    // \f
    case 13:
    // \r
    case 32:
    case 160:
    case 5760:
    case 8239:
    case 8287:
    case 12288:
      return !0;
  }
  return !1;
}
function q(t) {
  return Dt.test(t) || dt.test(t);
}
function J(t) {
  switch (t) {
    case 33:
    case 34:
    case 35:
    case 36:
    case 37:
    case 38:
    case 39:
    case 40:
    case 41:
    case 42:
    case 43:
    case 44:
    case 45:
    case 46:
    case 47:
    case 58:
    case 59:
    case 60:
    case 61:
    case 62:
    case 63:
    case 64:
    case 91:
    case 92:
    case 93:
    case 94:
    case 95:
    case 96:
    case 123:
    case 124:
    case 125:
    case 126:
      return !0;
    default:
      return !1;
  }
}
function x(t, e, s) {
  this.type = t, this.tag = e, this.attrs = null, this.map = null, this.nesting = s, this.level = 0, this.children = null, this.content = "", this.markup = "", this.info = "", this.meta = null, this.block = !1, this.hidden = !1;
}
x.prototype.attrIndex = function (e) {
  if (!this.attrs) return -1;
  const s = this.attrs;
  for (let r = 0, u = s.length; r < u; r++) if (s[r][0] === e) return r;
  return -1;
};
x.prototype.attrPush = function (e) {
  this.attrs ? this.attrs.push(e) : this.attrs = [e];
};
x.prototype.attrSet = function (e, s) {
  const r = this.attrIndex(e),
    u = [e, s];
  r < 0 ? this.attrPush(u) : this.attrs[r] = u;
};
x.prototype.attrGet = function (e) {
  const s = this.attrIndex(e);
  let r = null;
  return s >= 0 && (r = this.attrs[s][1]), r;
};
x.prototype.attrJoin = function (e, s) {
  const r = this.attrIndex(e);
  r < 0 ? this.attrPush([e, s]) : this.attrs[r][1] = this.attrs[r][1] + " " + s;
};
function ft(t, e, s) {
  this.src = t, this.env = s, this.tokens = [], this.inlineMode = !1, this.md = e;
}
ft.prototype.Token = x;
function _(t, e, s, r) {
  this.src = t, this.md = e, this.env = s, this.tokens = r, this.bMarks = [], this.eMarks = [], this.tShift = [], this.sCount = [], this.bsCount = [], this.blkIndent = 0, this.line = 0, this.lineMax = 0, this.tight = !1, this.ddIndent = -1, this.listIndent = -1, this.parentType = "root", this.level = 0;
  const u = this.src;
  for (let i = 0, o = 0, n = 0, a = 0, c = u.length, h = !1; o < c; o++) {
    const D = u.charCodeAt(o);
    if (!h) if (O(D)) {
      n++, D === 9 ? a += 4 - a % 4 : a++;
      continue;
    } else h = !0;
    (D === 10 || o === c - 1) && (D !== 10 && o++, this.bMarks.push(i), this.eMarks.push(o), this.tShift.push(n), this.sCount.push(a), this.bsCount.push(0), h = !1, n = 0, a = 0, i = o + 1);
  }
  this.bMarks.push(u.length), this.eMarks.push(u.length), this.tShift.push(0), this.sCount.push(0), this.bsCount.push(0), this.lineMax = this.bMarks.length - 1;
}
_.prototype.push = function (t, e, s) {
  const r = new x(t, e, s);
  return r.block = !0, s < 0 && this.level--, r.level = this.level, s > 0 && this.level++, this.tokens.push(r), r;
};
_.prototype.isEmpty = function (e) {
  return this.bMarks[e] + this.tShift[e] >= this.eMarks[e];
};
_.prototype.skipEmptyLines = function (e) {
  for (let s = this.lineMax; e < s && !(this.bMarks[e] + this.tShift[e] < this.eMarks[e]); e++);
  return e;
};
_.prototype.skipSpaces = function (e) {
  for (let s = this.src.length; e < s; e++) {
    const r = this.src.charCodeAt(e);
    if (!O(r)) break;
  }
  return e;
};
_.prototype.skipSpacesBack = function (e, s) {
  if (e <= s) return e;
  for (; e > s;) if (!O(this.src.charCodeAt(--e))) return e + 1;
  return e;
};
_.prototype.skipChars = function (e, s) {
  for (let r = this.src.length; e < r && this.src.charCodeAt(e) === s; e++);
  return e;
};
_.prototype.skipCharsBack = function (e, s, r) {
  if (e <= r) return e;
  for (; e > r;) if (s !== this.src.charCodeAt(--e)) return e + 1;
  return e;
};
_.prototype.getLines = function (e, s, r, u) {
  if (e >= s) return "";
  const i = new Array(s - e);
  for (let o = 0, n = e; n < s; n++, o++) {
    let a = 0;
    const c = this.bMarks[n];
    let h = c,
      D;
    for (n + 1 < s || u ? D = this.eMarks[n] + 1 : D = this.eMarks[n]; h < D && a < r;) {
      const g = this.src.charCodeAt(h);
      if (O(g)) g === 9 ? a += 4 - (a + this.bsCount[n]) % 4 : a++;else if (h - c < this.tShift[n]) a++;else break;
      h++;
    }
    a > r ? i[o] = new Array(a - r + 1).join(" ") + this.src.slice(h, D) : i[o] = this.src.slice(h, D);
  }
  return i.join("");
};
_.prototype.Token = x;
const Ft = ["address", "article", "aside", "base", "basefont", "blockquote", "body", "caption", "center", "col", "colgroup", "dd", "details", "dialog", "dir", "div", "dl", "dt", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hr", "html", "iframe", "legend", "li", "link", "main", "menu", "menuitem", "nav", "noframes", "ol", "optgroup", "option", "p", "param", "search", "section", "summary", "table", "tbody", "td", "tfoot", "th", "thead", "title", "tr", "track", "ul"],
  Et = "[a-zA-Z_:][a-zA-Z0-9:._-]*",
  pt = "[^\"'=<>`\\x00-\\x20]+",
  Ct = "'[^']*'",
  At = '"[^"]*"',
  gt = "(?:" + pt + "|" + Ct + "|" + At + ")",
  yt = "(?:\\s+" + Et + "(?:\\s*=\\s*" + gt + ")?)",
  bt = "<[A-Za-z][A-Za-z0-9\\-]*" + yt + "*\\s*\\/?>",
  kt = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>",
  mt = new RegExp("^(?:" + bt + "|" + kt + ")");
new RegExp("^</?(" + Ft.join("|") + ")(?=(\\s|/?>|$))", "i"), new RegExp(mt.source + "\\s*$");
function I(t, e, s, r) {
  this.src = t, this.env = s, this.md = e, this.tokens = r, this.tokens_meta = Array(r.length), this.pos = 0, this.posMax = this.src.length, this.level = 0, this.pending = "", this.pendingLevel = 0, this.cache = {}, this.delimiters = [], this._prev_delimiters = [], this.backticks = {}, this.backticksScanned = !1, this.linkLevel = 0;
}
I.prototype.pushPending = function () {
  const t = new x("text", "", 0);
  return t.content = this.pending, t.level = this.pendingLevel, this.tokens.push(t), this.pending = "", t;
};
I.prototype.push = function (t, e, s) {
  this.pending && this.pushPending();
  const r = new x(t, e, s);
  let u = null;
  return s < 0 && (this.level--, this.delimiters = this._prev_delimiters.pop()), r.level = this.level, s > 0 && (this.level++, this._prev_delimiters.push(this.delimiters), this.delimiters = [], u = {
    delimiters: this.delimiters
  }), this.pendingLevel = this.level, this.tokens.push(r), this.tokens_meta.push(u), r;
};
I.prototype.scanDelims = function (t, e) {
  const s = this.posMax,
    r = this.src.charCodeAt(t),
    u = t > 0 ? this.src.charCodeAt(t - 1) : 32;
  let i = t;
  for (; i < s && this.src.charCodeAt(i) === r;) i++;
  const o = i - t,
    n = i < s ? this.src.charCodeAt(i) : 32,
    a = J(u) || q(String.fromCharCode(u)),
    c = J(n) || q(String.fromCharCode(n)),
    h = G(u),
    D = G(n),
    g = !D && (!c || h || a),
    k = !h && (!a || D || c);
  return {
    can_open: g && (e || !k || a),
    can_close: k && (e || !g || c),
    length: o
  };
};
I.prototype.Token = x;
const Q = [];
for (let t = 0; t < 256; t++) Q.push(0);
"\\!\"#$%&'()*+,./:;<=>?@[]^_`{|}~-".split("").forEach(function (t) {
  Q[t.charCodeAt(0)] = 1;
});
let b = /* @__PURE__ */function (t) {
    return t.DOCUMENT = "doc", t.HEADING = "heading", t.PARAGRAPH = "paragraph", t.QUOTE = "blockquote", t.OL_LIST = "ordered_list", t.UL_LIST = "bullet_list", t.LIST_ITEM = "list_item", t.CODE_BLOCK = "code_block", t.HR = "horizontal_rule", t.BR = "hard_break", t.IMAGE = "image", t.EMOJI = "emoji", t.COMPONENT = "blok", t.TABLE = "table", t.TABLE_ROW = "tableRow", t.TABLE_CELL = "tableCell", t.TABLE_HEADER = "tableHeader", t;
  }({}),
  v = /* @__PURE__ */function (t) {
    return t.BOLD = "bold", t.STRONG = "strong", t.STRIKE = "strike", t.UNDERLINE = "underline", t.ITALIC = "italic", t.CODE = "code", t.LINK = "link", t.ANCHOR = "anchor", t.STYLED = "styled", t.SUPERSCRIPT = "superscript", t.SUBSCRIPT = "subscript", t.TEXT_STYLE = "textStyle", t.HIGHLIGHT = "highlight", t;
  }({}),
  vt = /* @__PURE__ */function (t) {
    return t.TEXT = "text", t;
  }({}),
  L = /* @__PURE__ */function (t) {
    return t.URL = "url", t.STORY = "story", t.ASSET = "asset", t.EMAIL = "email", t;
  }({});
function xt(t, e) {
  if (!e) return {
    src: t,
    attrs: {}
  };
  let s = 0,
    r = 0;
  const u = {},
    i = [];
  function o(a, c, h, D, g) {
    typeof a != "number" || a <= c || a >= h ? console.warn(`[StoryblokRichText] - ${D.charAt(0).toUpperCase() + D.slice(1)} value must be a number between ${c} and ${h} (inclusive)`) : g.push(`${D}(${a})`);
  }
  if (typeof e == "object") {
    if (typeof e.width == "number" && e.width > 0 ? (u.width = e.width, s = e.width) : console.warn("[StoryblokRichText] - Width value must be a number greater than 0"), e.height && typeof e.height == "number" && e.height > 0 ? (u.height = e.height, r = e.height) : console.warn("[StoryblokRichText] - Height value must be a number greater than 0"), e.loading && ["lazy", "eager"].includes(e.loading) && (u.loading = e.loading), e.class && (u.class = e.class), e.filters) {
      const {
          filters: a
        } = e || {},
        {
          blur: c,
          brightness: h,
          fill: D,
          format: g,
          grayscale: k,
          quality: w,
          rotate: R
        } = a || {};
      c && o(c, 0, 100, "blur", i), w && o(w, 0, 100, "quality", i), h && o(h, 0, 100, "brightness", i), D && i.push(`fill(${D})`), k && i.push("grayscale()"), R && [0, 90, 180, 270].includes(e.filters.rotate || 0) && i.push(`rotate(${R})`), g && ["webp", "png", "jpeg"].includes(g) && i.push(`format(${g})`);
    }
    e.srcset && (u.srcset = e.srcset.map(a => {
      if (typeof a == "number") return `${t}/m/${a}x0/${i.length > 0 ? `filters:${i.join(":")}` : ""} ${a}w`;
      if (Array.isArray(a) && a.length === 2) {
        const [c, h] = a;
        return `${t}/m/${c}x${h}/${i.length > 0 ? `filters:${i.join(":")}` : ""} ${c}w`;
      } else {
        console.warn("[StoryblokRichText] - srcset entry must be a number or a tuple of two numbers");
        return;
      }
    }).join(", ")), e.sizes && (u.sizes = e.sizes.join(", "));
  }
  let n = `${t}/m/`;
  return s > 0 && r > 0 && (n = `${n}${s}x${r}/`), i.length > 0 && (n = `${n}filters:${i.join(":")}`), {
    src: n,
    attrs: u
  };
}
const _t = ["area", "base", "br", "col", "embed", "hr", "img", "input", "link", "meta", "param", "source", "track", "wbr"],
  Bt = (t = {}) => Object.keys(t).map(e => `${e}="${t[e]}"`).join(" "),
  wt = (t = {}) => Object.keys(t).map(e => `${e}: ${t[e]}`).join("; ");
function Rt(t) {
  return t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
}
const T = t => Object.fromEntries(Object.entries(t).filter(([e, s]) => s !== void 0));
function V(t, e = {}, s) {
  const r = Bt(e),
    u = r ? `${t} ${r}` : t,
    i = Array.isArray(s) ? s.join("") : s || "";
  if (t) {
    if (_t.includes(t)) return `<${u}>`;
  } else return i;
  return `<${u}>${i}</${t}>`;
}
function St(t = {}) {
  const e = /* @__PURE__ */new Map(),
    {
      renderFn: s = V,
      textFn: r = Rt,
      resolvers: u = {},
      optimizeImages: i = !1,
      keyedResolvers: o = !1
    } = t,
    n = s !== V,
    a = l => (f, d) => {
      const F = f.attrs || {};
      return d.render(l, F, f.children || null);
    },
    c = (l, f) => {
      const {
        src: d,
        alt: F,
        title: p,
        srcset: C,
        sizes: A
      } = l.attrs || {};
      let y = d,
        m = {};
      if (i) {
        const {
          src: at,
          attrs: ct
        } = xt(d, i);
        y = at, m = ct;
      }
      const ot = {
        src: y,
        alt: F,
        title: p,
        srcset: C,
        sizes: A,
        ...m
      };
      return f.render("img", T(ot));
    },
    h = (l, f) => {
      const {
        level: d,
        ...F
      } = l.attrs || {};
      return f.render(`h${d}`, F, l.children);
    },
    D = (l, f) => {
      var F, p, C, A;
      const d = f.render("img", {
        src: (F = l.attrs) == null ? void 0 : F.fallbackImage,
        alt: (p = l.attrs) == null ? void 0 : p.alt,
        style: "width: 1.25em; height: 1.25em; vertical-align: text-top",
        draggable: "false",
        loading: "lazy"
      });
      return f.render("span", {
        "data-type": "emoji",
        "data-name": (C = l.attrs) == null ? void 0 : C.name,
        "data-emoji": (A = l.attrs) == null ? void 0 : A.emoji
      }, d);
    },
    g = (l, f) => f.render("pre", l.attrs || {}, f.render("code", {}, l.children || "")),
    k = (l, f = !1) => ({
      text: d,
      attrs: F
    }, p) => {
      const {
          class: C,
          id: A,
          ...y
        } = F || {},
        m = f ? {
          class: C,
          id: A,
          style: wt(y) || void 0
        } : F || {};
      return p.render(l, T(m), d);
    },
    w = l => N(l),
    R = l => {
      const {
        marks: f,
        ...d
      } = l;
      if ("text" in l) {
        if (f) return f.reduce((p, C) => w({
          ...C,
          text: p
        }), w({
          ...d,
          children: d.children
        }));
        const F = l.attrs || {};
        if (o) {
          const p = e.get("txt") || 0;
          e.set("txt", p + 1), F.key = `txt-${p}`;
        }
        return r(d.text, F);
      }
      return "";
    },
    U = (l, f) => {
      const {
        linktype: d,
        href: F,
        anchor: p,
        ...C
      } = l.attrs || {};
      let A = "";
      switch (d) {
        case L.ASSET:
        case L.URL:
          A = F;
          break;
        case L.EMAIL:
          A = `mailto:${F}`;
          break;
        case L.STORY:
          A = F, p && (A = `${A}#${p}`);
          break;
        default:
          A = F;
          break;
      }
      const y = {
        ...C
      };
      return A && (y.href = A), f.render("a", y, l.text);
    },
    et = (l, f) => {
      var d, F;
      return console.warn("[StoryblokRichtText] - BLOK resolver is not available for vanilla usage"), f.render("span", {
        blok: (d = l == null ? void 0 : l.attrs) == null ? void 0 : d.body[0],
        id: (F = l.attrs) == null ? void 0 : F.id,
        style: "display: none"
      });
    },
    st = (l, f) => {
      const d = {},
        F = f.render("tbody", {}, l.children);
      return f.render("table", d, F);
    },
    rt = (l, f) => {
      const d = {};
      return f.render("tr", d, l.children);
    },
    ut = (l, f) => {
      const {
          colspan: d,
          rowspan: F,
          colwidth: p,
          backgroundColor: C,
          ...A
        } = l.attrs || {},
        y = {
          ...A
        };
      d > 1 && (y.colspan = d), F > 1 && (y.rowspan = F);
      const m = [];
      return p && m.push(`width: ${p}px;`), C && m.push(`background-color: ${C};`), m.length > 0 && (y.style = m.join(" ")), f.render("td", T(y), l.children);
    },
    it = (l, f) => {
      const {
          colspan: d,
          rowspan: F,
          colwidth: p,
          backgroundColor: C,
          ...A
        } = l.attrs || {},
        y = {
          ...A
        };
      d > 1 && (y.colspan = d), F > 1 && (y.rowspan = F);
      const m = [];
      return p && m.push(`width: ${p}px;`), C && m.push(`background-color: ${C};`), m.length > 0 && (y.style = m.join(" ")), f.render("th", T(y), l.children);
    },
    M = /* @__PURE__ */new Map([[b.DOCUMENT, a("")], [b.HEADING, h], [b.PARAGRAPH, a("p")], [b.UL_LIST, a("ul")], [b.OL_LIST, a("ol")], [b.LIST_ITEM, a("li")], [b.IMAGE, c], [b.EMOJI, D], [b.CODE_BLOCK, g], [b.HR, a("hr")], [b.BR, a("br")], [b.QUOTE, a("blockquote")], [b.COMPONENT, et], [vt.TEXT, R], [v.LINK, U], [v.ANCHOR, U], [v.STYLED, k("span", !0)], [v.BOLD, k("strong")], [v.TEXT_STYLE, k("span", !0)], [v.ITALIC, k("em")], [v.UNDERLINE, k("u")], [v.STRIKE, k("s")], [v.CODE, k("code")], [v.SUPERSCRIPT, k("sup")], [v.SUBSCRIPT, k("sub")], [v.HIGHLIGHT, k("mark")], [b.TABLE, st], [b.TABLE_ROW, rt], [b.TABLE_CELL, ut], [b.TABLE_HEADER, it]]),
    z = new Map([...M, ...Object.entries(u).map(([l, f]) => [l, f])]),
    nt = () => ({
      render: (d, F = {}, p) => {
        if (o && d) {
          const C = e.get(d) || 0;
          e.set(d, C + 1), F.key = `${d}-${C}`;
        }
        return s(d, F, p);
      },
      originalResolvers: M,
      mergedResolvers: z
    });
  function S(l) {
    const f = z.get(l.type);
    if (!f) return console.error("<Storyblok>", `No resolver found for node type ${l.type}`), "";
    const d = nt();
    if (l.type === "text") return f(l, d);
    const F = l.content ? l.content.map(N) : void 0;
    return f({
      ...l,
      children: F
    }, d);
  }
  function N(l) {
    return l.type === "doc" ? n ? l.content.map(S) : l.content.map(S).join("") : Array.isArray(l) ? l.map(S) : S(l);
  }
  return {
    render: N
  };
}
let K = !1;
const Y = [],
  tt = t => new Promise((e, s) => {
    if (typeof window > "u") {
      s(new Error("Cannot load Storyblok bridge: window is undefined (server-side environment)"));
      return;
    }
    if (window.storyblokRegisterEvent = u => {
      if (!window.location.search.includes("_storyblok")) {
        console.warn("You are not in Draft Mode or in the Visual Editor.");
        return;
      }
      K ? u() : Y.push(u);
    }, document.getElementById("storyblok-javascript-bridge")) {
      e(void 0);
      return;
    }
    const r = document.createElement("script");
    r.async = !0, r.src = t, r.id = "storyblok-javascript-bridge", r.onerror = u => s(u), r.onload = u => {
      Y.forEach(i => i()), K = !0, e(u);
    }, document.getElementsByTagName("head")[0].appendChild(r);
  });
var Lt = class extends Error {
  constructor(t) {
    super(t), this.name = "AbortError";
  }
};
function Tt(t, e, s) {
  if (!Number.isFinite(e)) throw new TypeError("Expected `limit` to be a finite number");
  if (!Number.isFinite(s)) throw new TypeError("Expected `interval` to be a finite number");
  const r = [];
  let u = [],
    i = 0,
    o = !1;
  const n = async () => {
      i++;
      const c = r.shift();
      if (c) try {
        const D = await t(...c.args);
        c.resolve(D);
      } catch (D) {
        c.reject(D);
      }
      const h = setTimeout(() => {
        i--, r.length > 0 && n(), u = u.filter(D => D !== h);
      }, s);
      u.includes(h) || u.push(h);
    },
    a = (...c) => o ? Promise.reject(/* @__PURE__ */new Error("Throttled function is already aborted and not accepting new promises")) : new Promise((h, D) => {
      r.push({
        resolve: h,
        reject: D,
        args: c
      }), i < e && n();
    });
  return a.abort = () => {
    o = !0, u.forEach(clearTimeout), u = [], r.forEach(c => c.reject(() => new Lt("Throttle function aborted"))), r.length = 0;
  }, a;
}
var Pt = Tt;
const W = (t = "") => t.includes("/cdn/"),
  Ot = (t, e = 25, s = 1) => ({
    ...t,
    per_page: e,
    page: s
  }),
  It = t => new Promise(e => setTimeout(e, t)),
  Nt = (t = 0, e) => Array.from({
    length: t
  }, e),
  $t = (t = 0, e = t) => {
    const s = Math.abs(e - t) || 0,
      r = t < e ? 1 : -1;
    return Nt(s, (u, i) => i * r + t);
  },
  jt = async (t, e) => Promise.all(t.map(e)),
  Ht = (t = [], e) => t.map(e).reduce((s, r) => [...s, ...r], []),
  H = (t, e, s) => {
    const r = [];
    for (const u in t) {
      if (!Object.prototype.hasOwnProperty.call(t, u)) continue;
      const i = t[u];
      if (i == null) continue;
      const o = s ? "" : encodeURIComponent(u);
      let n;
      typeof i == "object" ? n = H(i, e ? e + encodeURIComponent(`[${o}]`) : o, Array.isArray(i)) : n = `${e ? e + encodeURIComponent(`[${o}]`) : o}=${encodeURIComponent(i)}`, r.push(n);
    }
    return r.join("&");
  },
  Z = t => {
    const e = {
      eu: "api.storyblok.com",
      us: "api-us.storyblok.com",
      cn: "app.storyblokchina.cn",
      ap: "api-ap.storyblok.com",
      ca: "api-ca.storyblok.com"
    };
    return e[t] ?? e.eu;
  };
var Ut = class {
    constructor(t) {
      E(this, "baseURL");
      E(this, "timeout");
      E(this, "headers");
      E(this, "responseInterceptor");
      E(this, "fetch");
      E(this, "ejectInterceptor");
      E(this, "url");
      E(this, "parameters");
      E(this, "fetchOptions");
      this.baseURL = t.baseURL, this.headers = t.headers || new Headers(), this.timeout = t != null && t.timeout ? t.timeout * 1e3 : 0, this.responseInterceptor = t.responseInterceptor, this.fetch = (...e) => t.fetch ? t.fetch(...e) : fetch(...e), this.ejectInterceptor = !1, this.url = "", this.parameters = {}, this.fetchOptions = {};
    }
    /**
    *
    * @param url string
    * @param params ISbStoriesParams
    * @returns Promise<ISbResponse | Error>
    */
    get(t, e) {
      return this.url = t, this.parameters = e, this._methodHandler("get");
    }
    post(t, e) {
      return this.url = t, this.parameters = e, this._methodHandler("post");
    }
    put(t, e) {
      return this.url = t, this.parameters = e, this._methodHandler("put");
    }
    delete(t, e) {
      return this.url = t, this.parameters = e ?? {}, this._methodHandler("delete");
    }
    async _responseHandler(t) {
      const e = [],
        s = {
          data: {},
          headers: {},
          status: 0,
          statusText: ""
        };
      t.status !== 204 && (await t.json().then(r => {
        s.data = r;
      }));
      for (const r of t.headers.entries()) e[r[0]] = r[1];
      return s.headers = {
        ...e
      }, s.status = t.status, s.statusText = t.statusText, s;
    }
    async _methodHandler(t) {
      let e = `${this.baseURL}${this.url}`,
        s = null;
      t === "get" ? e = `${this.baseURL}${this.url}?${H(this.parameters)}` : s = JSON.stringify(this.parameters);
      const r = new URL(e),
        u = new AbortController(),
        {
          signal: i
        } = u;
      let o;
      this.timeout && (o = setTimeout(() => u.abort(), this.timeout));
      try {
        const n = await this.fetch(`${r}`, {
          method: t,
          headers: this.headers,
          body: s,
          signal: i,
          ...this.fetchOptions
        });
        this.timeout && clearTimeout(o);
        const a = await this._responseHandler(n);
        return this.responseInterceptor && !this.ejectInterceptor ? this._statusHandler(this.responseInterceptor(a)) : this._statusHandler(a);
      } catch (n) {
        return {
          message: n
        };
      }
    }
    setFetchOptions(t = {}) {
      Object.keys(t).length > 0 && "method" in t && delete t.method, this.fetchOptions = {
        ...t
      };
    }
    eject() {
      this.ejectInterceptor = !0;
    }
    /**
    * Normalizes error messages from different response structures
    * @param data The response data that might contain error information
    * @returns A normalized error message string
    */
    _normalizeErrorMessage(t) {
      if (Array.isArray(t)) return t[0] || "Unknown error";
      if (t && typeof t == "object") {
        if (t.error) return t.error;
        for (const e in t) {
          if (Array.isArray(t[e])) return `${e}: ${t[e][0]}`;
          if (typeof t[e] == "string") return `${e}: ${t[e]}`;
        }
        if (t.slug) return t.slug;
      }
      return "Unknown error";
    }
    _statusHandler(t) {
      const e = /20[0-6]/g;
      return new Promise((s, r) => {
        if (e.test(`${t.status}`)) return s(t);
        const u = {
          message: this._normalizeErrorMessage(t.data),
          status: t.status,
          response: t
        };
        r(u);
      });
    }
  },
  Mt = Ut;
const X = "SB-Agent",
  $ = {
    defaultAgentName: "SB-JS-CLIENT",
    defaultAgentVersion: "SB-Agent-Version",
    packageVersion: "7.0.0"
  },
  zt = {
    PUBLISHED: "published"
  };
let P = {};
const B = {};
var Gt = class {
    /**
    *
    * @param config ISbConfig interface
    * @param pEndpoint string, optional
    */
    constructor(t, e) {
      E(this, "client");
      E(this, "maxRetries");
      E(this, "retriesDelay");
      E(this, "throttle");
      E(this, "accessToken");
      E(this, "cache");
      E(this, "resolveCounter");
      E(this, "relations");
      E(this, "links");
      E(this, "version");
      /**
      * @deprecated This property is deprecated. Use the standalone `richTextResolver` from `@storyblok/richtext` instead.
      * @see https://github.com/storyblok/richtext
      */
      E(this, "richTextResolver");
      E(this, "resolveNestedRelations");
      E(this, "stringifiedStoriesCache");
      E(this, "inlineAssets");
      let s = t.endpoint || e;
      if (!s) {
        const i = t.https === !1 ? "http" : "https";
        t.oauthToken ? s = `${i}://${Z(t.region)}/v1` : s = `${i}://${Z(t.region)}/v2`;
      }
      const r = new Headers();
      r.set("Content-Type", "application/json"), r.set("Accept", "application/json"), t.headers && (t.headers.constructor.name === "Headers" ? t.headers.entries().toArray() : Object.entries(t.headers)).forEach(([o, n]) => {
        r.set(o, n);
      }), r.has(X) || (r.set(X, $.defaultAgentName), r.set($.defaultAgentVersion, $.packageVersion));
      let u = 5;
      t.oauthToken && (r.set("Authorization", t.oauthToken), u = 3), t.rateLimit && (u = t.rateLimit), this.maxRetries = t.maxRetries || 10, this.retriesDelay = 300, this.throttle = Pt(this.throttledRequest.bind(this), u, 1e3), this.accessToken = t.accessToken || "", this.relations = {}, this.links = {}, this.cache = t.cache || {
        clear: "manual"
      }, this.resolveCounter = 0, this.resolveNestedRelations = t.resolveNestedRelations || !0, this.stringifiedStoriesCache = {}, this.version = t.version || zt.PUBLISHED, this.inlineAssets = t.inlineAssets || !1, this.client = new Mt({
        baseURL: s,
        timeout: t.timeout || 0,
        headers: r,
        responseInterceptor: t.responseInterceptor,
        fetch: t.fetch
      });
    }
    parseParams(t) {
      return t.token || (t.token = this.getToken()), t.cv || (t.cv = B[t.token]), Array.isArray(t.resolve_relations) && (t.resolve_relations = t.resolve_relations.join(",")), typeof t.resolve_relations < "u" && (t.resolve_level = 2), t;
    }
    factoryParamOptions(t, e) {
      return W(t) ? this.parseParams(e) : e;
    }
    makeRequest(t, e, s, r, u) {
      const i = this.factoryParamOptions(t, Ot(e, s, r));
      return this.cacheResponse(t, i, void 0, u);
    }
    get(t, e = {}, s) {
      e || (e = {});
      const r = `/${t}`;
      W(r) && (e.version = e.version || this.version);
      const u = this.factoryParamOptions(r, e);
      return this.cacheResponse(r, u, void 0, s);
    }
    async getAll(t, e = {}, s, r) {
      const u = (e == null ? void 0 : e.per_page) || 25,
        i = `/${t}`.replace(/\/$/, ""),
        o = s ?? i.substring(i.lastIndexOf("/") + 1);
      e.version = e.version || this.version;
      const n = 1,
        a = await this.makeRequest(i, e, u, n, r),
        c = a.total ? Math.ceil(a.total / (a.perPage || u)) : 1,
        h = await jt($t(n, c), D => this.makeRequest(i, e, u, D + 1, r));
      return Ht([a, ...h], D => Object.values(D.data[o]));
    }
    post(t, e = {}, s) {
      const r = `/${t}`;
      return this.throttle("post", r, e, s);
    }
    put(t, e = {}, s) {
      const r = `/${t}`;
      return this.throttle("put", r, e, s);
    }
    delete(t, e = {}, s) {
      e || (e = {});
      const r = `/${t}`;
      return this.throttle("delete", r, e, s);
    }
    getStories(t = {}, e) {
      return this._addResolveLevel(t), this.get("cdn/stories", t, e);
    }
    getStory(t, e = {}, s) {
      return this._addResolveLevel(e), this.get(`cdn/stories/${t}`, e, s);
    }
    getToken() {
      return this.accessToken;
    }
    ejectInterceptor() {
      this.client.eject();
    }
    _addResolveLevel(t) {
      typeof t.resolve_relations < "u" && (t.resolve_level = 2);
    }
    _cleanCopy(t) {
      return JSON.parse(JSON.stringify(t));
    }
    _insertLinks(t, e, s) {
      const r = t[e];
      r && r.fieldtype === "multilink" && r.linktype === "story" && typeof r.id == "string" && this.links[s][r.id] ? r.story = this._cleanCopy(this.links[s][r.id]) : r && r.linktype === "story" && typeof r.uuid == "string" && this.links[s][r.uuid] && (r.story = this._cleanCopy(this.links[s][r.uuid]));
    }
    /**
    *
    * @param resolveId A counter number as a string
    * @param uuid The uuid of the story
    * @returns string | object
    */
    getStoryReference(t, e) {
      return this.relations[t][e] ? JSON.parse(this.stringifiedStoriesCache[e] || JSON.stringify(this.relations[t][e])) : e;
    }
    /**
    * Resolves a field's value by replacing UUIDs with their corresponding story references
    * @param jtree - The JSON tree object containing the field to resolve
    * @param treeItem - The key of the field to resolve
    * @param resolveId - The unique identifier for the current resolution context
    *
    * This method handles both single string UUIDs and arrays of UUIDs:
    * - For single strings: directly replaces the UUID with the story reference
    * - For arrays: maps through each UUID and replaces with corresponding story references
    */
    _resolveField(t, e, s) {
      const r = t[e];
      typeof r == "string" ? t[e] = this.getStoryReference(s, r) : Array.isArray(r) && (t[e] = r.map(u => this.getStoryReference(s, u)).filter(Boolean));
    }
    /**
    * Inserts relations into the JSON tree by resolving references
    * @param jtree - The JSON tree object to process
    * @param treeItem - The current field being processed
    * @param fields - The relation patterns to resolve (string or array of strings)
    * @param resolveId - The unique identifier for the current resolution context
    *
    * This method handles two types of relation patterns:
    * 1. Nested relations: matches fields that end with the current field name
    *    Example: If treeItem is "event_type", it matches patterns like "*.event_type"
    *
    * 2. Direct component relations: matches exact component.field patterns
    *    Example: "event.event_type" for component "event" and field "event_type"
    *
    * The method supports both string and array formats for the fields parameter,
    * allowing flexible specification of relation patterns.
    */
    _insertRelations(t, e, s, r) {
      if (Array.isArray(s) ? s.find(o => o.endsWith(`.${e}`)) : s.endsWith(`.${e}`)) {
        this._resolveField(t, e, r);
        return;
      }
      const i = t.component ? `${t.component}.${e}` : e;
      (Array.isArray(s) ? s.includes(i) : s === i) && this._resolveField(t, e, r);
    }
    /**
    * Recursively traverses and resolves relations in the story content tree
    * @param story - The story object containing the content to process
    * @param fields - The relation patterns to resolve
    * @param resolveId - The unique identifier for the current resolution context
    */
    iterateTree(t, e, s) {
      const r = (u, i = "") => {
        if (!(!u || u._stopResolving)) {
          if (Array.isArray(u)) u.forEach((o, n) => r(o, `${i}[${n}]`));else if (typeof u == "object") for (const o in u) {
            const n = i ? `${i}.${o}` : o;
            (u.component && u._uid || u.type === "link") && (this._insertRelations(u, o, e, s), this._insertLinks(u, o, s)), r(u[o], n);
          }
        }
      };
      r(t.content);
    }
    async resolveLinks(t, e, s) {
      let r = [];
      if (t.link_uuids) {
        const u = t.link_uuids.length,
          i = [],
          o = 50;
        for (let n = 0; n < u; n += o) {
          const a = Math.min(u, n + o);
          i.push(t.link_uuids.slice(n, a));
        }
        for (let n = 0; n < i.length; n++) (await this.getStories({
          per_page: o,
          language: e.language,
          version: e.version,
          starts_with: e.starts_with,
          by_uuids: i[n].join(",")
        })).data.stories.forEach(c => {
          r.push(c);
        });
      } else r = t.links;
      r.forEach(u => {
        this.links[s][u.uuid] = {
          ...u,
          _stopResolving: !0
        };
      });
    }
    async resolveRelations(t, e, s) {
      let r = [];
      if (t.rel_uuids) {
        const u = t.rel_uuids.length,
          i = [],
          o = 50;
        for (let n = 0; n < u; n += o) {
          const a = Math.min(u, n + o);
          i.push(t.rel_uuids.slice(n, a));
        }
        for (let n = 0; n < i.length; n++) (await this.getStories({
          per_page: o,
          language: e.language,
          version: e.version,
          starts_with: e.starts_with,
          by_uuids: i[n].join(","),
          excluding_fields: e.excluding_fields
        })).data.stories.forEach(c => {
          r.push(c);
        });
        r.length > 0 && (t.rels = r, delete t.rel_uuids);
      } else r = t.rels;
      r && r.length > 0 && r.forEach(u => {
        this.relations[s][u.uuid] = {
          ...u,
          _stopResolving: !0
        };
      });
    }
    /**
    *
    * @param responseData
    * @param params
    * @param resolveId
    * @description Resolves the relations and links of the stories
    * @returns Promise<void>
    *
    */
    async resolveStories(t, e, s) {
      var u, i;
      let r = [];
      if (this.links[s] = {}, this.relations[s] = {}, typeof e.resolve_relations < "u" && e.resolve_relations.length > 0 && (typeof e.resolve_relations == "string" && (r = e.resolve_relations.split(",")), await this.resolveRelations(t, e, s)), e.resolve_links && ["1", "story", "url", "link"].includes(e.resolve_links) && ((u = t.links) != null && u.length || (i = t.link_uuids) != null && i.length) && (await this.resolveLinks(t, e, s)), this.resolveNestedRelations) for (const o in this.relations[s]) this.iterateTree(this.relations[s][o], r, s);
      t.story ? this.iterateTree(t.story, r, s) : t.stories.forEach(o => {
        this.iterateTree(o, r, s);
      }), this.stringifiedStoriesCache = {}, delete this.links[s], delete this.relations[s];
    }
    async cacheResponse(t, e, s, r) {
      const u = H({
          url: t,
          params: e
        }),
        i = this.cacheProvider();
      if (e.version === "published" && t !== "/cdn/spaces/me") {
        const o = await i.get(u);
        if (o) return Promise.resolve(o);
      }
      return new Promise(async (o, n) => {
        var a;
        try {
          const c = await this.throttle("get", t, e, r);
          if (c.status !== 200) return n(c);
          let h = {
            data: c.data,
            headers: c.headers
          };
          if ((a = c.headers) != null && a["per-page"] && (h = Object.assign({}, h, {
            perPage: c.headers["per-page"] ? Number.parseInt(c.headers["per-page"]) : 0,
            total: c.headers["per-page"] ? Number.parseInt(c.headers.total) : 0
          })), h.data.story || h.data.stories) {
            const g = this.resolveCounter = ++this.resolveCounter % 1e3;
            await this.resolveStories(h.data, e, `${g}`), h = await this.processInlineAssets(h);
          }
          e.version === "published" && t !== "/cdn/spaces/me" && (await i.set(u, h));
          const D = this.cache.clear === "onpreview" && e.version === "draft" || this.cache.clear === "auto";
          return e.token && h.data.cv && (D && B[e.token] && B[e.token] !== h.data.cv && (await this.flushCache()), B[e.token] = h.data.cv), o(h);
        } catch (c) {
          if (c.response && c.status === 429 && (s = typeof s > "u" ? 0 : s + 1, s < this.maxRetries)) return console.log(`Hit rate limit. Retrying in ${this.retriesDelay / 1e3} seconds.`), await It(this.retriesDelay), this.cacheResponse(t, e, s).then(o).catch(n);
          n(c);
        }
      });
    }
    throttledRequest(t, e, s, r) {
      return this.client.setFetchOptions(r), this.client[t](e, s);
    }
    cacheVersions() {
      return B;
    }
    cacheVersion() {
      return B[this.accessToken];
    }
    setCacheVersion(t) {
      this.accessToken && (B[this.accessToken] = t);
    }
    clearCacheVersion() {
      this.accessToken && (B[this.accessToken] = 0);
    }
    cacheProvider() {
      switch (this.cache.type) {
        case "memory":
          return {
            get(t) {
              return Promise.resolve(P[t]);
            },
            getAll() {
              return Promise.resolve(P);
            },
            set(t, e) {
              return P[t] = e, Promise.resolve(void 0);
            },
            flush() {
              return P = {}, Promise.resolve(void 0);
            }
          };
        case "custom":
          if (this.cache.custom) return this.cache.custom;
        default:
          return {
            get() {
              return Promise.resolve();
            },
            getAll() {
              return Promise.resolve(void 0);
            },
            set() {
              return Promise.resolve(void 0);
            },
            flush() {
              return Promise.resolve(void 0);
            }
          };
      }
    }
    async flushCache() {
      return await this.cacheProvider().flush(), this.clearCacheVersion(), this;
    }
    async processInlineAssets(t) {
      if (!this.inlineAssets) return t;
      const e = s => {
        if (!s || typeof s != "object") return s;
        if (Array.isArray(s)) return s.map(u => e(u));
        let r = {
          ...s
        };
        r.fieldtype === "asset" && Array.isArray(t.data.assets) && (r = {
          ...r,
          ...t.data.assets.find(u => u.id === r.id)
        });
        for (const u in r) typeof r[u] == "object" && (r[u] = e(r[u]));
        return r;
      };
      return t.data.story && (t.data.story.content = e(t.data.story.content)), t.data.stories && (t.data.stories = t.data.stories.map(s => (s.content = e(s.content), s))), t;
    }
  },
  qt = Gt;
const Vt = (t = {}) => {
    const {
      apiOptions: e
    } = t;
    if (!e || !e.accessToken) {
      console.error("You need to provide an access token to interact with Storyblok API. Read https://www.storyblok.com/docs/api/content-delivery#topics/authentication");
      return;
    }
    return {
      storyblokApi: new qt(e)
    };
  },
  Kt = t => {
    if (typeof t != "object" || typeof t._editable > "u") return {};
    try {
      const e = JSON.parse(t._editable.replace(/^<!--#storyblok#/, "").replace(/-->$/, ""));
      return e ? {
        "data-blok-c": JSON.stringify(e),
        "data-blok-uid": `${e.id}-${e.uid}`
      } : {};
    } catch {
      return {};
    }
  };
let j = "https://app.storyblok.com/f/storyblok-v2-latest.js";
const Yt = (t, e, s = {}) => {
    var n;
    const u = !(typeof window > "u") && typeof window.storyblokRegisterEvent < "u",
      i = new URL((n = window.location) == null ? void 0 : n.href).searchParams.get("_storyblok"),
      o = i !== null && +i === t;
    if (!(!u || !o)) {
      if (!t) {
        console.warn("Story ID is not defined. Please provide a valid ID.");
        return;
      }
      window.storyblokRegisterEvent(() => {
        new window.StoryblokBridge(s).on(["input", "published", "change"], c => {
          var h;
          c && (c.action === "input" && ((h = c.story) == null ? void 0 : h.id) === t ? e(c.story) : (c.action === "change" || c.action === "published") && c.storyId === t && window.location.reload());
        });
      });
    }
  },
  Wt = (t = {}) => {
    var h, D;
    const {
      bridge: e,
      accessToken: s,
      use: r = [],
      apiOptions: u = {},
      bridgeUrl: i
    } = t;
    u.accessToken = u.accessToken || s;
    const o = {
      bridge: e,
      apiOptions: u
    };
    let n = {};
    r.forEach(g => {
      n = {
        ...n,
        ...g(o)
      };
    }), i && (j = i);
    const c = !(typeof window > "u") && ((D = (h = window.location) == null ? void 0 : h.search) == null ? void 0 : D.includes("_storyblok_tk"));
    return e !== !1 && c && tt(j), n;
  };
function Zt(t, e) {
  return St(e).render(t);
}
const Xt = () => tt(j);
export { b as BlockTypes, v as MarkTypes, vt as TextTypes, Vt as apiPlugin, Xt as loadStoryblokBridge, Yt as registerStoryblokBridge, Zt as renderRichText, St as richTextResolver, Kt as storyblokEditable, Wt as storyblokInit, Yt as useStoryblokBridge };